module.exports = __webpack_public_path__ + "img/map-marker.7ac1a02f.svg";